import { objectEntries } from 'lib/object/objectUtils'
// eslint-disable-next-line no-restricted-imports
import { getContentColourUtilityClassName } from 'lib/theme/utilityClassNames'
import { css, ExecutionContext } from 'styled-components'

const contentColours: Record<App.Design.ContentColour, (props: ExecutionContext) => string> = {
  'inherit': () => 'inherit',
  'critical-contrast': props => props.theme.palette.messaging.critical.normalContrast,
  'critical-dark-contrast': props => props.theme.palette.messaging.critical.darkContrast,
  'critical-dark': props => props.theme.palette.messaging.critical.darkForeground,
  'critical-light-contrast': props => props.theme.palette.messaging.critical.lightContrast,
  'critical-light': props => props.theme.palette.messaging.critical.lightForeground,
  'critical': props => props.theme.palette.messaging.critical.normalForeground,
  'exclusive-contrast': props => props.theme.palette.product.exclusive.contrast,
  'exclusive': props => props.theme.palette.product.exclusive.foreground,
  'favourite-contrast': props => props.theme.palette.messaging.favourite.normalContrast,
  'favourite-dark-contrast': props => props.theme.palette.messaging.favourite.darkContrast,
  'favourite-dark': props => props.theme.palette.messaging.favourite.darkForeground,
  'favourite-light-contrast': props => props.theme.palette.messaging.favourite.lightContrast,
  'favourite-light': props => props.theme.palette.messaging.favourite.lightForeground,
  'favourite': props => props.theme.palette.messaging.favourite.normalForeground,
  'highlight-lux-plus': props => props.theme.palette.highlight.luxPlus.normalForeground,
  'highlight-primary-contrast': props => props.theme.palette.highlight.primary.normalContrast,
  'highlight-primary-light-contrast': props => props.theme.palette.highlight.primary.lightContrast,
  'highlight-primary-light': props => props.theme.palette.highlight.primary.lightForeground,
  'highlight-primary': props => props.theme.palette.highlight.primary.normalForeground,
  'highlight-secondary-contrast': props => props.theme.palette.highlight.secondary.normalContrast,
  'highlight-secondary-light-contrast': props => props.theme.palette.highlight.secondary.lightContrast,
  'highlight-secondary-light': props => props.theme.palette.highlight.secondary.lightForeground,
  'highlight-secondary': props => props.theme.palette.highlight.secondary.normalForeground,
  'highlight-tertiary-contrast': props => props.theme.palette.highlight.tertiary.normalContrast,
  'highlight-tertiary-light-contrast': props => props.theme.palette.highlight.tertiary.lightContrast,
  'highlight-tertiary-light': props => props.theme.palette.highlight.tertiary.lightForeground,
  'highlight-tertiary': props => props.theme.palette.highlight.tertiary.normalForeground,
  'lux-plus-alt': props => props.theme.palette.product.luxPlus.altForeground,
  'lux-plus-contrast': props => props.theme.palette.product.luxPlus.contrast,
  'lux-plus': props => props.theme.palette.product.luxPlus.foreground,
  'neutral-eight': props => props.theme.palette.neutral.default.eight,
  'neutral-five': props => props.theme.palette.neutral.default.five,
  'neutral-four': props => props.theme.palette.neutral.default.four,
  'neutral-one': props => props.theme.palette.neutral.default.one,
  'neutral-six': props => props.theme.palette.neutral.default.six,
  'neutral-three': props => props.theme.palette.neutral.default.three,
  'neutral-two': props => props.theme.palette.neutral.default.two,
  'primary-dark': props => props.theme.palette.brand.primary.dark,
  'primary': props => props.theme.palette.brand.primary.normal,
  'success-contrast': props => props.theme.palette.messaging.success.normalContrast,
  'success-dark-contrast': props => props.theme.palette.messaging.success.darkContrast,
  'success-dark': props => props.theme.palette.messaging.success.darkForeground,
  'success-light-contrast': props => props.theme.palette.messaging.success.lightContrast,
  'success-light': props => props.theme.palette.messaging.success.lightForeground,
  'success': props => props.theme.palette.messaging.success.normalForeground,
  'tier-bronze-contrast': props => props.theme.palette.product.loyalty.bronze.normalContrast,
  'tier-bronze-dark-contrast': props => props.theme.palette.product.loyalty.bronze.darkContrast,
  'tier-bronze-dark': props => props.theme.palette.product.loyalty.bronze.darkForeground,
  'tier-bronze-light-contrast': props => props.theme.palette.product.loyalty.bronze.lightContrast,
  'tier-bronze-light': props => props.theme.palette.product.loyalty.bronze.lightForeground,
  'tier-bronze': props => props.theme.palette.product.loyalty.bronze.normalForeground,
  'tier-gold-contrast': props => props.theme.palette.product.loyalty.gold.normalContrast,
  'tier-gold-dark-contrast': props => props.theme.palette.product.loyalty.gold.darkContrast,
  'tier-gold-dark': props => props.theme.palette.product.loyalty.gold.darkForeground,
  'tier-gold-light-contrast': props => props.theme.palette.product.loyalty.gold.lightContrast,
  'tier-gold-light': props => props.theme.palette.product.loyalty.gold.lightForeground,
  'tier-gold': props => props.theme.palette.product.loyalty.gold.normalForeground,
  'tier-platinum-contrast': props => props.theme.palette.product.loyalty.platinum.normalContrast,
  'tier-platinum-dark-contrast': props => props.theme.palette.product.loyalty.platinum.darkContrast,
  'tier-platinum-dark': props => props.theme.palette.product.loyalty.platinum.darkForeground,
  'tier-platinum-light-contrast': props => props.theme.palette.product.loyalty.platinum.lightContrast,
  'tier-platinum-light': props => props.theme.palette.product.loyalty.platinum.lightForeground,
  'tier-platinum': props => props.theme.palette.product.loyalty.platinum.normalForeground,
  'tier-silver-contrast': props => props.theme.palette.product.loyalty.silver.normalContrast,
  'tier-silver-dark-contrast': props => props.theme.palette.product.loyalty.silver.darkContrast,
  'tier-silver-dark': props => props.theme.palette.product.loyalty.silver.darkForeground,
  'tier-silver-light-contrast': props => props.theme.palette.product.loyalty.silver.lightContrast,
  'tier-silver-light': props => props.theme.palette.product.loyalty.silver.lightForeground,
  'tier-silver': props => props.theme.palette.product.loyalty.silver.normalForeground,
  'urgency-dark-contrast': props => props.theme.palette.messaging.urgency.darkContrast,
  'urgency-dark': props => props.theme.palette.messaging.urgency.darkForeground,
  'urgency-light-contrast': props => props.theme.palette.messaging.urgency.lightContrast,
  'urgency-light': props => props.theme.palette.messaging.urgency.lightForeground,
  'urgency': props => props.theme.palette.messaging.urgency.normalForeground,
  'warning-contrast': props => props.theme.palette.messaging.warning.normalContrast,
  'warning-dark-contrast': props => props.theme.palette.messaging.warning.darkContrast,
  'warning-dark': props => props.theme.palette.messaging.warning.darkForeground,
  'warning-light-contrast': props => props.theme.palette.messaging.warning.lightContrast,
  'warning-light': props => props.theme.palette.messaging.warning.lightForeground,
  'warning': props => props.theme.palette.messaging.warning.normalForeground,
}

const contentColoursStyle = objectEntries(contentColours).map(([colour, getter]) => css`.${getContentColourUtilityClassName(colour)} { color: ${getter}; }`)

export default contentColoursStyle
